import { ENV } from '@components/Environment.js';
export function isMobile() {
    return ENV('mobile');
}
